import React, { Component } from 'react';

import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import moment from 'moment';

import { extend } from 'jquery';
import { filter } from 'lodash';

import { DropdownButton, MenuItem } from 'react-bootstrap';

// INNER IMPORTS
import '../mainAdminstyles.css';
import './styles.css';

import { convertArrayOfObjectsToCSV, isBandFinderType, capitalizeAll } from '../../../../utils';
import * as adminActions from '../../../../Actions/admin';
import {
    closePinModal,
    closeBandFinderPinModal,
    openBandFinderPinModal,
    getDatatypes,
} from '../../../../Actions/main';

import { editPin, editBandFinderPin, closeSubmitModal, closeSubmitBandFinderModal } from '../../../../Actions/users';
import { openPinFullViewModal } from '../../../../Actions/modals';

import {
    ENROL_TYPE_FREE,
    ENROL_TYPE_HIGH,
    ENROL_TYPE_MEDIUM,
    ENROL_TYPE_HUGE
} from '../../../../Models/consts';

import { LIVE_MUSIC, BAND } from '../../../../consts';

import { SimpleDatePicker } from '../../../Elements/Pickers';
import { ButtonSimple } from '../../../Elements/Buttons';
import FaErrowDown from 'react-icons/lib/fa/angle-down';
import FaErrowUp from 'react-icons/lib/fa/angle-up';
import SVGInline from "react-svg-inline";
import lineEyeSVG from "../../../inlineSVGs/lineEyeSVG";

class AdminPins extends Component {
    constructor() {
        super();
        this.state = {
            type: LIVE_MUSIC,
            userEmail: '',
            title: ''
        };
    }

    componentWillMount() {
        this.props.clearAdminPins();
        this.props.getAdminPins(this.props.token, this.props.query);
        this.props.getDatatypes();
        this.setState({ type: this.props.query.type });
    }

    dateHandler(startDate, endDate) {
        this.setState({
            startDate,
            endDate,
        });
    }

    resetDates() {
        this.setState({startDate: '', endDate: '', sortType: ''});
        // this.props.getAdminPins(this.props.token, {
        //     type: this.props.query.type,
        //     title: this.state.title,
        //     userEmail: this.state.userEmail
        // });
    }

    handleSearchClick() {
        this.props.getAdminPins(this.props.token, {
            startDate: this.state.startDate,
            endDate: this.state.endDate,
            type: this.props.query.type,
            title: this.state.title,
            userEmail: this.state.userEmail
        });
    }

    updateTitleSearch(event) {
        if (!event) return;

        this.setState({title: event.target.value});
    }

    updateEmailSearch(event) {
        if (!event) return;

        this.setState({userEmail: event.target.value});
    }

    downloadCSV() {
        let data, filename, link;

        let pins = extend(true, {}, this.props.pins);

        // using lodash to prevent pass to 'pins' a value and not a reference for the array AND the objects in it
        pins = filter(pins, (pin) => {
            return this.state.userSearch ? pin.name.includes(this.state.userSearch) : true;
        });

        const formattedPins = pins.map((pin)=> {
            return {
                'Name': pin.name || '',
                'On Hold': pin.isOnHold || 'No',
                'Active': pin.isActive || 'No',
                'Verified User': pin.isUserVerified || 'No',
                'Type': pin.type,
                'Category': pin.category,
                'Instruments': pin.instruments ? pin.instruments.join(' | ') : '',
                'Sub Categories': pin.subCategories ? pin.subCategories.join(' | ') : '',
                'Looking For': pin.lookingForTypes ? pin.lookingForTypes.join(' | ') : '',
                'Event Date': pin.date ? moment(pin.date).format('DD.MM.YY') : '',
                'Publish Date': pin.publishDate ? moment(pin.publishDate).format('DD.MM.YY') : '',
                'Bounce Date': pin.bounceDate ? moment(pin.bounceDate).format('DD.MM.YY') : '',
                'Address': pin.location ? `${pin.location.city || ''} ${pin.location.street || ''} ${pin.location.number ||''}` : '' ,
                'Description': pin.desc ? pin.desc.split(',').join('') : '',
                'Price': pin.price || '',
                'Contact Info': pin.contactInfo || '',
                'Email': pin.email || '',
                'Phone': pin.phone || '',
                'Ticket Link': pin.ticketLink || '',
                'Video Link': pin.video || '',
                'Link 1': pin.link1 || '',
                'Link 2': pin.link2 || '',
            }
        });

        let csv = convertArrayOfObjectsToCSV({ data: formattedPins });

        if (csv === null) return;

        filename = `${this.props.query.type === LIVE_MUSIC ? 'event' : this.props.query.type}s-report.csv`;

        const csvFinal = 'data:text/csv;charset=utf-8,' + csv.replace('data:text/csv;', '');

        // if (!csv.match(/^data:text\/csv/i)) {
        //     csv = 'data:text/csv;charset=utf-8,' + csv;
        // }

        data = encodeURI(csvFinal);

        link = document.createElement('a');
        link.setAttribute('href', data);
        link.setAttribute('download', filename);
        link.click();
    }

    sortByName() {
        if (this.state.sortName) {
            this.props.pins.sort((a, b) => {
                if (a.name.toLowerCase() > b.name.toLowerCase()) return 1;
                if (a.name.toLowerCase() < b.name.toLowerCase()) return -1;

                return 0;
            });
        } else {
            this.props.pins.sort((a, b) => {
                if (a.name.toLowerCase() < b.name.toLowerCase()) return 1;
                if (a.name.toLowerCase() > b.name.toLowerCase()) return -1;

                return 0;
            });
        }

        this.setState({sortName: !this.state.sortName, pins: this.props.pins, sortType: 'name'});
    }

    sortByCategoryIWeAre() {
        if (isBandFinderType(this.props.query.type)) {
            this.sortByIWeAre();
            return;
        }

        this.sortByCategory();
    }

    sortByCategory() {
        if (this.state.sortCategory) {
            this.props.pins.sort((a, b) => {
                if (a.category > b.category) return 1;
                if (a.category < b.category) return -1;

                return 0;
            });
        } else {
            this.props.pins.sort((a, b) => {
                if (a.category < b.category) return 1;
                if (a.category > b.category) return -1;

                return 0;
            });
        }

        this.setState({sortCategory: !this.state.sortCategory, pins: this.props.pins, sortType: 'category'});
    }

    sortByIWeAre() {
        if (this.state.sortIWeAre) {
            this.props.pins.sort((a, b) => {
                if (a.iWeAre > b.iWeAre) return 1;
                if (a.iWeAre < b.iWeAre) return -1;

                return 0;
            });
        } else {
            this.props.pins.sort((a, b) => {
                if (a.iWeAre < b.iWeAre) return 1;
                if (a.iWeAre > b.iWeAre) return -1;

                return 0;
            });
        }

        this.setState({sortIWeAre: !this.state.sortIWeAre, pins: this.props.pins, sortType: 'iWeAre'});
    }

    catIWeAreHelper() {
        // this.state.sortType === 'category' ? this.renderArrow(this.state.sortCategory) : null
        if (this.state.sortType === 'category') {
            return this.renderArrow(this.state.sortCategory);
        }

        if (this.state.sortType === 'iWeAre') {
            return this.renderArrow(this.state.sortIWeAre);
        }

        return null;
    }

    sortByType() {
        if (this.state.sortEventType) {
            this.props.pins.sort((a, b) => {
                if (a.subscription.enrolType > b.subscription.enrolType) return 1;
                if (a.subscription.enrolType < b.subscription.enrolType) return -1;

                return 0;
            });
        } else {
            this.props.pins.sort((a, b) => {
                if (a.subscription.enrolType < b.subscription.enrolType) return 1;
                if (a.subscription.enrolType > b.subscription.enrolType) return -1;

                return 0;
            });
        }

        this.setState({sortEventType: !this.state.sortEventType, pins: this.props.pins, sortType: 'type'});
    }

    sortByPayouts() {
        if (this.state.sortPayouts) {
            this.props.pins.sort((a, b) => a.subscription.payouts - b.subscription.payouts);
        } else {
            this.props.pins.sort((a, b) => b.subscription.payouts - a.subscription.payouts);
        }

        this.setState({sortPayouts: !this.state.sortPayouts, pins: this.props.pins, sortType: 'payouts'});
    }

    sortByPublishDate() {
        if (this.state.sortPublishDate) {
            this.props.pins.sort((a, b) => {
                if (a.publishDate > b.publishDate) return 1;
                if (a.publishDate < b.publishDate) return -1;

                return 0;
            });
        } else {
            this.props.pins.sort((a, b) => {
                if (a.publishDate < b.publishDate) return 1;
                if (a.publishDate > b.publishDate) return -1;

                return 0;
            });
        }

        this.setState({sortPublishDate: !this.state.sortPublishDate, pins: this.props.pins, sortType: 'publishDate'});
    }

    sortByUpgrade() {
        if (this.state.sortUpgrade) {
            this.props.pins.sort((a, b) => {
                if (a.subscription.upgrade > b.subscription.upgrade) return 1;
                if (a.subscription.upgrade < b.subscription.upgrade) return -1;

                return 0;
            });
        } else {
            this.props.pins.sort((a, b) => {
                if (a.subscription.upgrade < b.subscription.upgrade) return 1;
                if (a.subscription.upgrade > b.subscription.upgrade) return -1;

                return 0;
            })
        }

        this.setState({ sortUpgrade: !this.state.sortUpgrade, pins: this.props.pins, sortType: 'upgrade'})
    }

    sortByEventDate() {
        if (this.state.sortEventDate) {
            this.props.pins.sort((a, b) => {
                if (a.date > b.date) return 1;
                if (a.date < b.date) return -1;

                return 0;
            });
        } else {
            this.props.pins.sort((a, b) => {
                if (a.date < b.date) return 1;
                if (a.date > b.date) return -1;

                return 0;
            });
        }

        this.setState({sortEventDate: !this.state.sortEventDate, pins: this.props.pins, sortType: 'eventDate'});
    }

    setPinStatus(pin, action) {
        let message = 'put this pin ON HOLD?';
        if (action !== 'onHold') {
            message = `${action.toUpperCase()} this pin?`
        }

        if (window.confirm(`Are you sure you want to ${message}`))
            this.props.setAdminPinStatus(this.props.token, {
                action,
                pinId: pin._id,
                type: pin.type
            })
    }

    setUpgradeSelections(pin, upgrade) {
        if (window.confirm('Are you sure you want to upgrade this ad?')) {
            this.props.upgradeEnrollType(this.props.token, this.props.query, {
                upgrade,
                pinId: pin._id
            })
        }
    }

    getStatusLabel(pin) {
        if (pin.isOnHold) return 'On Hold';
        if (pin.isActive) return 'Approved';

        return 'Disapproved'
    }

    getEnrollUpgradeTitle(pin) {
        if (!pin.subscription) return;

        if (pin.subscription.upgrade === 'mid') return 'Push';
        if (pin.subscription.upgrade === 'high') return 'Rule';
        if (pin.subscription.upgrade === 'huge') return 'Super';

        return 'None'
    }

    getStatusClass(pin) {
        if (pin.isOnHold) return 'warning';
        if (pin.isActive) return 'success';

        return 'danger'
    }

    renderArrow(direction) {
        if (direction) return <i><FaErrowUp /></i>;
        return <i><FaErrowDown /></i>
    }

    handleOpenPin(pin) {
        if (isBandFinderType(this.props.query.type)) {
            this.props.openPinFullViewModal(pin);

            return;
        }

        this.props.openPinFullViewModal(pin);
    }

    handleToggleRepeat(pin) {
        this.props.toggleRepeat(pin);
    }

    handleOpenEdit(pin) {
        if (isBandFinderType(this.props.query.type)) {
            this.props.editBandFinderPin(pin);

            return;
        }

        this.props.editPin(pin)
    }

    handleViewsClick() {
        if (!this.state.viewsRangeMin || !this.state.viewsRangeMax) return alert('Views count range must have min and max values above 0');

        if (this.state.viewsRangeMin > this.state.viewsRangeMax) return alert('Views count range min cant be higher than max');

        if (!window.confirm(`Are you sure you want to add views to ${this.props.pins.length} pins?`)) return;

        this.props.incPinsView(this.state.type, this.state.viewsRangeMin, this.state.viewsRangeMax);
    }

    renderPinType(pin) {
        if (pin.subscription.enrolType === ENROL_TYPE_FREE) return 'Free';
        if (pin.subscription.enrolType === ENROL_TYPE_MEDIUM) return 'Push';
        if (pin.subscription.enrolType === ENROL_TYPE_HIGH) return 'Rule';
        if (pin.subscription.enrolType === ENROL_TYPE_HUGE) return 'Super';

        return null;
    }

    renderEnrollType(pin) {
        let enrollLetter;
        if (pin.subscription.enrolType === ENROL_TYPE_FREE) enrollLetter = 'F';
        if (pin.subscription.enrolType === ENROL_TYPE_MEDIUM) enrollLetter = 'P';
        if (pin.subscription.enrolType === ENROL_TYPE_HIGH) enrollLetter = 'R';
        if (pin.subscription.enrolType === ENROL_TYPE_HUGE) enrollLetter = 'S';

        return (
            <div className={`enroll-type ${pin.subscription.enrolType}`}>
                {enrollLetter}
            </div>
        )
    }

    renderCategoryHeader() {
        if (!isBandFinderType(this.props.query.type)) {
            return 'Category';
        }

        if (this.props.query.type === BAND) {
            return 'We are';
        }

        return 'I am';
    }

    renderHeader() {
        if (this.props.query.type === LIVE_MUSIC) {
            return 'Music Events';
        }

        return `${capitalizeAll(this.props.query.type)}s`;
    }

    renderFilteredPins() {
        if (!this.props.pins) return null;
        const pins = this.props.pins.filter((pin) => {
            return this.state.userSearch ? pin.name.toLowerCase().includes(this.state.userSearch) : true;
        });

        return pins.map((pin) => {
            return (
                <tr key={pin._id}>
                    <td className="name event-name">
                        {pin.name.length > 15 ? pin.name.slice(0, 15) + '...' : pin.name}
                    </td>
                    <td>
                        {!isBandFinderType(pin.type) ? pin.category : pin.iWeAre}
                    </td>
                    <td className="enroll-type-wrapper">{this.renderEnrollType(pin)}</td>
                    <td>{pin.subscription.payouts || 0}</td>
                    {this.props.query.type === LIVE_MUSIC ? <td>{moment(pin.date).format('DD.MM.YY')}</td> : null}
                    <td>{moment(pin.publishDate).format('DD.MM.YY')}</td>
                    <td>{(pin.interactions && pin.interactions.viewsCount) || 0}</td>
                    <td className="buttons-wrapper enroll-type">
                        <div className={`buttons ${pin.subscription.upgrade}`}>
                            <DropdownButton
                                bsStyle={pin.subscription && pin.subscription.upgrade}
                                title={this.getEnrollUpgradeTitle(pin)}
                                id={pin._id}
                                noCaret={true}
                            >
                                <MenuItem eventKey="huge" onSelect={(eventKey) => this.setUpgradeSelections(pin, eventKey)}>Super</MenuItem>
                                <MenuItem eventKey="high" onSelect={(eventKey) => this.setUpgradeSelections(pin, eventKey)}>Rule</MenuItem>
                                <MenuItem eventKey="mid" onSelect={(eventKey) => this.setUpgradeSelections(pin, eventKey)}>Push</MenuItem>
                                <MenuItem eventKey="none" onSelect={(eventKey) => this.setUpgradeSelections(pin, eventKey)}>None</MenuItem>
                            </DropdownButton>
                        </div>
                    </td>
                    {pin.type === LIVE_MUSIC ?
                        <td className="repeat-wrapper">
                            <div className={`repeat-button ${pin.isRepeat ? 'repeat' : ''}`}>
                                <ButtonSimple label={pin.isRepeat ? 'Repeat' : 'One Time'} onPress={() => this.handleToggleRepeat(pin)} />
                            </div>
                        </td>
                    : null }
                    <td className="buttons-wrapper">
                        <div className="buttons">
                            <div className="event-buttons">
                                <ButtonSimple label="See" onPress={() => this.handleOpenPin(pin)} />
                                <ButtonSimple label="Edit" onPress={() => this.handleOpenEdit(pin)}/>
                            </div>
                            <DropdownButton
                                bsStyle={this.getStatusClass(pin)}
                                title={this.getStatusLabel(pin)}
                                id={pin._id}
                                noCaret={true}
                            >
                                <MenuItem eventKey="approve" onSelect={(eventKey) => this.setPinStatus(pin, eventKey)}>Approve</MenuItem>
                                <MenuItem eventKey="onHold" onSelect={(eventKey) => this.setPinStatus(pin, eventKey)}>ON Hold</MenuItem>
                                <MenuItem eventKey="disapprove" onSelect={(eventKey) => this.setPinStatus(pin, eventKey)}>Disapprove</MenuItem>
                            </DropdownButton>
                        </div>
                    </td>

                </tr>
            )
        })
    }

    render() {
        return (
            <div className={`admin-wrapper admin-pins-wrapper ${this.props.query.type}`}>

                <div className="content">
                    <div className="top-bar">
                        <div className="title">{this.renderHeader()}</div>
                    </div>
                    <div className="inner-nav">
                        <div className="inner-nav-row">
                            <SimpleDatePicker
                                datePickHandler={(startDate, endDate) => this.dateHandler(startDate, endDate)}
                                label="Dates Range"
                            />

                            {this.state.startDate && this.state.endDate ?
                                <div className="selected-dates">
                                    <span>{moment(this.state.startDate).format('DD.MM.YY')} - {moment(this.state.endDate).format('DD.MM.YY')}</span>
                                </div> : null
                            }

                            <div className="users-btn" onClick={() => this.resetDates()}>Reset Dates</div>
                            <input
                                type="text"
                                name="user-search"
                                onChange={(event) => this.updateTitleSearch(event)}
                                placeholder={`Search by title`}
                            />
                            <input
                                type="text"
                                name="user-search"
                                onChange={(event) => this.updateEmailSearch(event)}
                                placeholder={`Search by user email`}
                            />
                            <div className="users-btn" onClick={()=> this.handleSearchClick()}>Search</div>
                            <div className="views-count-wrapper">
                                <input
                                    type="number"
                                    className="views-count-input"
                                    name="views-range-min"
                                    onChange={ event => this.setState({ viewsRangeMin: parseInt(event.target.value, 10)})}
                                />
                                <div className="users-btn eye-btn" onClick={() => this.handleViewsClick()}>
                                    <SVGInline className="arrow-side-icon" svg={lineEyeSVG} component="i"/>
                                </div>
                                <input
                                    type="number"
                                    className="views-count-input"
                                    name="views-range-max"
                                    onChange={ event => this.setState({ viewsRangeMax: parseInt(event.target.value, 10)})}
                                />

                            </div>
                            <div className="users-btn push-right" onClick={()=>this.downloadCSV()}>Export</div>
                        </div>
                    </div>
                    <div className="table-wrapper">
                        <div className="table-scroll">
                            {this.props.isMorePages
                                ? <p className="results-label">More results available - narrow search</p>
                                : <p className="results-label">{this.props.pins.length} results</p>}
                            <table>
                                <thead>
                                <tr>
                                    <th onClick={() => this.sortByName()}>
                                        <span className="text">Event Name</span>
                                        {this.state.sortType === 'name' ? this.renderArrow(this.state.sortName) : null}
                                    </th>
                                    <th onClick={() => this.sortByCategoryIWeAre()}>
                                        <span className="text">{this.renderCategoryHeader()}</span>
                                        {this.catIWeAreHelper()}
                                    </th>
                                    <th onClick={() => this.sortByType()}>
                                        <span className="text">Enroll Type</span>
                                        {this.state.sortType === 'type' ? this.renderArrow(this.state.sortEventType) : null}
                                    </th>
                                    <th onClick={() => this.sortByPayouts()}>
                                        <span className="text">Pyouts</span>
                                        {this.state.sortType === 'payouts' ? this.renderArrow(this.state.sortPayouts) : null}
                                    </th>
                                    {this.props.query.type === LIVE_MUSIC ?
                                        <th onClick={() => this.sortByEventDate()}>
                                            <span className="text">Event Date</span>
                                            {this.state.sortType === 'eventDate' ? this.renderArrow(this.state.sortEventDate) : null}
                                        </th>
                                        : null}
                                    <th onClick={() => this.sortByPublishDate()}>
                                        <span className="text">Published</span>
                                        {this.state.sortType === 'publishDate' ? this.renderArrow(this.state.sortPublishDate) : null}
                                    </th>
                                    <th>
                                        <span className="text">Views</span>
                                    </th>
                                    <th onClick={() => this.sortByUpgrade()}>
                                        <span>Upgrade</span>
                                        {this.state.sortType === 'upgrade' ? this.renderArrow(this.state.sortUpgrade) : null}
                                    </th>
                                    {this.props.query.type === LIVE_MUSIC ?
                                        <th>
                                            <span>Repeat</span>
                                        </th>
                                    : null}

                                    <th><span className="empty"></span></th>
                                </tr>
                                </thead>
                                <tbody>
                                    {this.renderFilteredPins()}
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

AdminPins.propTypes = {
    token: PropTypes.string,
    getAdminPins: PropTypes.func,
    clearAdminPins: PropTypes.func,
    pins: PropTypes.array,
    isMorePages: PropTypes.bool,
    setAdminPinStatus: PropTypes.func,
    upgradeEnrollType: PropTypes.func,
    datatypes: PropTypes.object,

    // services and live music modals functions
    isModalOpen: PropTypes.bool,
    openPinFullViewModal: PropTypes.func,
    closePinModal: PropTypes.func,

    // band finder functions
    isBandFinderModalOpen: PropTypes.bool,
    openBandFinderPinModal: PropTypes.func,
    closeBandFinderPinModal: PropTypes.func,

    modalPinData: PropTypes.object,
    getDatatypes: PropTypes.func,
    closeSubmitModal: PropTypes.func,
    isSubmitModalOpen: PropTypes.bool,
    editPin: PropTypes.func,
    editBandFinderPin: PropTypes.func,
    query: PropTypes.object,
    incPinsView: PropTypes.func,
    toggleRepeat: PropTypes.func
};

const mapStateToProps = (state) => ({
    token: state.users.token,
    pins: state.admin.pins,
    isMorePages: state.admin.isMorePages,
    isModalOpen: state.main.isModalOpen,
    isBandFinderModalOpen: state.main.isModalOpen,
    modalPinData: state.main.modalPinData,
    datatypes: state.main.datatypes,
    isSubmitModalOpen: state.users.isSubmitModalOpen,
    isSubmitBandFinderModalOpen: state.main.isSubmitBandFinderModalOpen,
});

export default connect(mapStateToProps, {...adminActions,
    closePinModal,
    closeBandFinderPinModal,
    openPinFullViewModal,
    openBandFinderPinModal,
    getDatatypes,
    editPin,
    editBandFinderPin,
    closeSubmitModal,
    closeSubmitBandFinderModal,
})(AdminPins);



// WEBPACK FOOTER //
// ./src/Components/Screens/Admin/AdminPins/AdminPins.js